import { Link, useSearchParams } from 'react-router-dom';

export default function TicketSuccessPage() {
  const [searchParams] = useSearchParams();
  const quantity = parseInt(searchParams.get('qty') || '1', 10);
  const ticketWord = quantity > 1 ? `${quantity} TICKETS` : 'TICKET';

  return (
    <div className="min-h-screen bg-black text-white font-mono flex flex-col items-center justify-center p-6">
      <div className="max-w-md text-center">
        <div className="text-6xl mb-6">*</div>
        <h1 className="text-3xl font-bold tracking-wider mb-4">{ticketWord} PURCHASED!</h1>
        <p className="text-gray-400 mb-8">
          Check your email for your {quantity > 1 ? 'tickets' : 'ticket'} with QR {quantity > 1 ? 'codes' : 'code'} for entry. You'll receive event details as the host confirms them.
        </p>

        <div className="space-y-4">
          <Link
            to="/register"
            className="block border border-white px-8 py-3 tracking-wider hover:bg-white hover:text-black transition-colors text-sm"
          >
            CREATE ACCOUNT TO MANAGE {quantity > 1 ? 'TICKETS' : 'TICKET'}
          </Link>
          <Link
            to="/login"
            className="block text-gray-500 text-sm tracking-wider hover:text-white transition-colors"
          >
            ALREADY HAVE AN ACCOUNT? LOG IN
          </Link>
        </div>
      </div>
    </div>
  );
}
